import { CellValue, WorksheetInstance } from "jspreadsheet-ce";
import { create } from "zustand";

interface SpreadsheetState {
  activeSheet: WorksheetInstance | null;
  setActiveSheet: (sheet: WorksheetInstance) => void;

  selectedCell: { address: string; value: CellValue | null } | null;
  setSelectedCell: (
    cell: { address: string; value: CellValue | null } | null,
  ) => void;

  data: any[][];
  setData: (data: any[][]) => void;
  updateCell: (address: string, value: CellValue | null) => void;
}

export const useSpreadsheetStore = create<SpreadsheetState>((set, get) => ({
  activeSheet: null,
  selectedCell: null,
  data: [[]],

  setActiveSheet: (sheet) =>
    set((state) => {
      if (state.activeSheet === sheet) return state;
      return { activeSheet: sheet };
    }),

  setSelectedCell: (cell) => set({ selectedCell: cell }),

  setData: (data) => set({ data }),

  updateCell: (address, value) => {
    const state = get();
    if (state.activeSheet && value) {
      state.activeSheet?.setValue(address, value);
    }
  },
}));
